import { render, staticRenderFns } from "./BusinessDashboardView.vue?vue&type=template&id=96df2e0a&scoped=true&"
import script from "./BusinessDashboardView.vue?vue&type=script&lang=ts&"
export * from "./BusinessDashboardView.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessDashboardView.vue?vue&type=style&index=0&id=96df2e0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96df2e0a",
  null
  
)

export default component.exports